import { IMAGE_TYPES } from '../../../types/enums';
import { pdfjs } from 'react-pdf';
// @ts-ignore
import pdfjsWorker from 'react-pdf/dist/esm/pdf.worker.entry';
import { ImageConvertorResult } from '../../../types/common';
import { ZplOptions } from '../../../types/badge';

export class ImageExtension {
  static async getImageFromPDF(pdfBlob: Blob, imageType: IMAGE_TYPES = IMAGE_TYPES.PNG, zplOptions: ZplOptions =
    {
      width: 640,
      height: 1180,
      scale: 2.2
    }): Promise<ImageConvertorResult> {
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    const pdfDocument = await pdfjs.getDocument({ url: URL.createObjectURL(pdfBlob) }).promise;
    const page = await pdfDocument.getPage(1);
    const canvas = document.createElement('canvas');
    const canvasContext = canvas.getContext('2d')!;
    const viewport = page.getViewport({ scale: zplOptions.scale ?? 2.2 });
    const render_context = {
      canvasContext,
      viewport
    };
    canvas.width = zplOptions.width as number;
    canvas.height = zplOptions.height as number;
    await page.render(render_context).promise;
    const image = new Image();
    image.src = canvas.toDataURL(imageType);
    return { image, canvas };
  }
}
